import router from "./router";
import i18n from "./i18n";

export const blogModuleRouter = router;
export const blogModuleI18n = i18n;
